export default function Spirits() {
  const buttons = document.querySelectorAll('.spirits__button');
  const slides = document.querySelectorAll('.spirits .slide');
  const title = document.querySelector(".spirits .title");

  slides[0].classList.add("active");
  buttons[0].classList.add("active");

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      const titleText = button.getAttribute('data-title');

      buttons.forEach(button => button.classList.remove('active'));
      slides.forEach(slide => slide.classList.remove('active'));

      button.classList.add('active');
      slides[index].classList.add('active');
      title.innerText = titleText;
    });
  });
}